import './Submenu.css';
import React, { useContext, useEffect } from 'react';
import { List, ListItemButton, ListItemText, ListItemIcon, Drawer } from '@mui/material';
import Divider from '@mui/material/Divider';
import { Link } from 'react-router-dom';
import { ProfileContext } from '../context/ProfileContext';

// Material-UI Icons
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import SecurityIcon from '@mui/icons-material/Security';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import InfoIcon from '@mui/icons-material/Info';
import SettingsIcon from '@mui/icons-material/Settings';

const SubMenu = () => {
  const { userProfile, userRole } = React.useContext(ProfileContext);
  const style = {
    py: 0,
    width: '99%',
    maxWidth: 360,
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: 'background.paper',
  };

  return (
    <Drawer variant="permanent" anchor="left" className="submenu" 
      sx={{
        '& .MuiDrawer-paper': {
          position: 'relative',
          border: 'none',
          mt: '2.6rem',
          minWidth: '300px',
          maxHeight: '300px',
        },
      }}>
      <List sx={style}>
        {/* Benutzerprofil mit Person-Icon */}
        <ListItemButton className="submenu-list-item" component={Link} to="/pages/user-profile">
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary="Benutzerprofil" />
        </ListItemButton>

        {/* Schulprofil mit Schul- oder Gebäude-Icon */}
        <ListItemButton className="submenu-list-item" component={Link} to="/pages/school-profile">
          <ListItemIcon>
            <SchoolIcon />
          </ListItemIcon>
          <ListItemText primary="Schulprofil" />
        </ListItemButton>

        {/* Sicherheitseinstellungen mit Schlüssel-Icon */}
        <ListItemButton className="submenu-list-item" component={Link} to="/pages/security">
          <ListItemIcon>
            <SecurityIcon />
          </ListItemIcon>
          <ListItemText primary="Sicherheitseinstellungen" />
        </ListItemButton>

        <ListItemButton className="submenu-list-item" component={Link} to="/pages/info">
          <ListItemIcon>
            <InfoIcon />
          </ListItemIcon>
          <ListItemText primary="Informationszentrum" />
        </ListItemButton>

        {userProfile?.schoolVerified && (userProfile?.schoolProfileComplete || userProfile?.adminProfileComplete) && (
          <>
          <Divider variant="middle" component="li" />
          <ListItemButton
            variant="contained"
            className="submenu-list-item"
            component={Link}
            to="/pages/configurator"
            sx={{
              borderRadius: '8px',
              '&:hover': {
                borderColor: '#1976d2'
              },
            }}
          >
            <ListItemIcon>
              <SettingsIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary="Konfigurator" sx={{ color: '#1976d2' }}/>
          </ListItemButton>
          </>
        )}

        {/* Adminbereich nur anzeigen, wenn die Rolle Admin ist, mit Admin-Icon */}
        {userRole === 'admin' && (
          <ListItemButton className="submenu-list-item" component={Link} to="/pages/admin">
            <ListItemIcon>
              <AdminPanelSettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Admin" />
          </ListItemButton>
        )}
      </List>
    </Drawer>
  );
};

export default SubMenu;
